var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_180_2350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 53,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4479 0.576172H0V50H52.4479V0.576172Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_180_2350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2245 7.76758L5.82812 26.6876V43.8219C5.82812 47.2295 8.44141 49.9999 11.6557 49.9999H40.7934C44.0076 49.9999 46.6209 47.2295 46.6209 43.8219V26.6876L26.2245 7.76758ZM31.9793 34.0337C31.9793 35.1824 31.1051 36.0994 30.0306 36.0994H22.2727C21.2074 36.0994 20.3241 35.1727 20.3241 34.0337V25.7996C20.3241 24.6509 21.1983 23.7338 22.2727 23.7338H30.0306C31.1051 23.7338 31.9793 24.6509 31.9793 25.7996V34.0337Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4479 25.2881C52.4479 27.6531 50.4265 28.3771 49.5342 28.3771C48.8512 28.3771 48.1684 28.1261 47.6129 27.6145L26.224 7.76772L4.83504 27.6145C4.2796 28.1261 3.59669 28.3771 2.91377 28.3771C2.03964 28.3771 0 27.6434 0 25.2881C0 24.5737 0.24585 23.6567 0.992502 22.9617L24.3027 1.33877C24.8582 0.827152 25.541 0.576172 26.224 0.576172C26.9069 0.576172 27.5898 0.827152 28.1452 1.33877L37.879 10.3741V5.20966C37.879 4.36018 38.5346 3.66516 39.3359 3.66516H45.1635C45.9648 3.66516 46.6204 4.36018 46.6204 5.20966V18.4826L51.4554 22.9617C52.2021 23.6664 52.4479 24.5737 52.4479 25.2881Z",
    fill: "#828284"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.37a7d08aed5f3d5d3c39d2f1cba02e3e.svg";
export { ForwardRef as ReactComponent };